<template>
  <span class="loading-dots-ui"></span>
</template>
